import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "col" };
const _hoisted_2 = { class: "text-left text-capitalize" };
const _hoisted_3 = { class: "col" };
const _hoisted_4 = { class: "modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "confirmDelete",
            "no-footer": "",
            centered: "",
            size: "lg",
            title: _ctx.$t('JTADM_LAYOUT_DELETE')
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('JTADM_LAYOUT_ARE_YOU_SURE')), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
                    _createVNode($setup["BContainer"], { class: "delete" }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hospitalToDelete, (value, key) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "row",
                                    key: key
                                }, [
                                    (!$setup.INVISIBLE_FIELDS.includes(key))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", _hoisted_1, [
                                                _createElementVNode("p", _hoisted_2, [
                                                    _createElementVNode("strong", null, _toDisplayString(key) + " :", 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_3, [
                                                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-end" }, null, -1)),
                                                _createTextVNode(_toDisplayString(value), 1)
                                            ])
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("footer", _hoisted_4, [
                    _createElementVNode("button", {
                        class: "btn btn-danger",
                        onClick: _withModifiers($setup.confirmedDelete, ["prevent"])
                    }, _toDisplayString(_ctx.$t('JTADM_DIALOG_BUTTON_DELETE')), 1),
                    _createElementVNode("button", {
                        class: "btn btn-info",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => ($setup.confirmDelete?.hide()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                ])
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
